import React from 'react'
import cn from 'classnames'
import * as styles from './header-banner.module.scss'

const HeaderBanner = ({ bannerData }) => (
  <div className={styles.banner}>
    <div className={styles.content}>
      <p className={styles.text}>{bannerData?.headerBannerText}</p>
      <a
        target="_blank"
        href={bannerData?.headerBannerUrl}
        className={cn(styles.button, 'button-primary')}
        rel="noreferrer"
      >
        <span className="button-primary__content">
          {bannerData?.headerBannerButton}
        </span>
      </a>
    </div>
  </div>
)

export default HeaderBanner
